import get from 'lodash/get';
import siteData from '../site_data_util';
import striptags from 'striptags';
import baseSeoUtil from '../base_seo_util';

const LATEST_ACTIVE_YEAR = 2023;
const POSTER_IMAGES = {
  2021: 'https://wp-cms-fastcompany-com.s3.amazonaws.com/uploads/2021/08/FC_Carousel_BWFI-padding.jpg',
  2022: 'https://wp-cms-fastcompany-com.s3.amazonaws.com/uploads/2022/07/BWFI_2022_Social_Share.jpg',
  2023: 'https://wp-cms-fastcompany-com.s3.amazonaws.com/uploads/2023/06/BWFI_SocialShare2.jpg'
};

/**
 * Handle DEFAULT LANDER meta data for the best workplaces for innovators page
 */
const bestWorkplacesForInnovatorsMeta = (state = {}, action = {}) => {
  // For pageData => legacy uses bestworkplacesmodel, new page uses franchisepagemodel, need both getters. State does not update properly for legacy so I am tapping into the redux action, not state
  const pageData =
    get(state, 'franchisePage.data') || get(action, 'bestWorkplacesPage');
  const site = get(state, 'config.site');
  const siteConf = siteData || {};
  const year = get(pageData, 'acf.franchise_year', LATEST_ACTIVE_YEAR);
  const seoTitle = get(pageData, 'acf.title');
  const defaultDescription =
    'And when talent and innovation intersect with mission, they can help change the world.';
  const pageExcerpt = striptags(get(pageData, 'excerpt.rendered'));

  return baseSeoUtil({
    site,
    siteConf,
    title: seoTitle || `Best Workplaces for Innovators ${year}`,
    url: `https://www.fastcompany.com/best-workplaces-for-innovators/${
      parseInt(year, 10) === LATEST_ACTIVE_YEAR ? 'list' : year
    }`,
    description: pageExcerpt || defaultDescription,
    image: POSTER_IMAGES[year],
    articleSection: 'Best Workplace for Innovators',
    config: state.config,
    facebookTitleOverride: seoTitle,
    twitterTitleOverride: seoTitle,
    socialDescriptionOverride: pageExcerpt,
    canonical: `https://www.fastcompany.com/best-workplaces-for-innovators/${
      parseInt(year, 10) === LATEST_ACTIVE_YEAR ? 'list' : year
    }`
  });
};

/**
 * Handle INDIVIDUALLY RANKED COMPANY meta data for the best workplaces for innovators page
 */
const bestWorkplacesForInnovatorsItemMeta = (state = {}, action = {}) => {
  const initialRank = get(action, 'bestWorkplacesPage.initialRank');
  const pageData = get(state, 'franchisePage.data');
  const site = get(state, 'config.site');
  const siteConf = siteData || {};
  const year = get(pageData, 'acf.franchise_year', LATEST_ACTIVE_YEAR);

  // If we find a matching company with this rank, then we can use it's data
  const matchingCompany = get(
    pageData,
    `externalList.workplaces.records`,
    []
  ).filter(
    item =>
      item.fields.Rank ===
      parseInt(initialRank, 10).toLocaleString('en-US', {
        minimumIntegerDigits: 3,
        useGrouping: false
      })
  )[0].fields;

  const seoTitle = matchingCompany
    ? `${get(
        matchingCompany,
        'Company'
      )} is number ${initialRank} on Fast Company's list of the Best Workplaces for Innovators in ${year}`
    : undefined;
  const defaultDescription =
    'When talent and innovation intersect with mission, they can help change the world.';
  const pageExcerpt = striptags(get(pageData, 'excerpt.rendered'));

  return baseSeoUtil({
    site,
    siteConf,
    title: seoTitle || `Best Workplaces for Innovators ${year}`,
    url: `https://www.fastcompany.com/best-workplaces-for-innovators/${
      parseInt(year, 10) === LATEST_ACTIVE_YEAR ? 'list' : year
    }`,
    description: pageExcerpt || defaultDescription,
    image: POSTER_IMAGES[year],
    articleSection: 'Best Workplace for Innovators',
    config: state.config,
    canonical: `https://www.fastcompany.com/best-workplaces-for-innovators/${
      parseInt(year, 10) === LATEST_ACTIVE_YEAR ? 'list' : year
    }`
  });
};

export { bestWorkplacesForInnovatorsMeta, bestWorkplacesForInnovatorsItemMeta };
